import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';

/**
 * InvalidControlScrollDirective provides a simple way to scroll to the first
 * invalid form field. It must be placed on a form that used ngSubmit.
 */
@Directive({
    selector: '[invalidControlScroll]',
    standalone: true,
})
export class InvalidControlScrollDirective {
    constructor(
        private el: ElementRef,
        private form: NgForm
    ) {}

    @HostListener('ngSubmit') onSubmit(): void {
        if (this.form.control.invalid) {
            this.scrollToFirstInvalidControl();
        }
    }

    private scrollToFirstInvalidControl(): void {
        const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector('.ng-invalid');

        // if somehow the invalid control has disappeared we don't try to scroll to it
        if (!firstInvalidControl) {
            return;
        }

        firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}
